export enum DriverUnavailabilityReason {
  SICK_LEAVE = 'sick-leave',
  VACATION = 'vacation',
}
